import '@accessible360/accessible-slick';
import $ from 'jquery';

const heroHome = (function () {
  function _init() {
    const $heroHome = $('.js-hero-home').find('.field--field-images');
    const $slides = $heroHome.find('.paragraph--type--bloc-image');
    const play = $('.js-hero-home').find('.play');
    const pause = $('.js-hero-home').find('.pause');

    $heroHome.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      fade: true,
      cssEase: 'linear',
      regionLabel: $heroHome.parent().data('label'),
    });

    pause.on('click', function () {
      if ($(this).hasClass('d-none')) {
        $(this).removeClass('d-none');
        $(this).siblings().addClass('d-none');
      } else {
        $(this).addClass('d-none');
        $(this).siblings().removeClass('d-none');
      }

      $heroHome.slick('slickPause');
    });

    play.on('click', function () {
      if ($(this).hasClass('d-none')) {
        $(this).removeClass('d-none');
        $(this).siblings().addClass('d-none');
      } else {
        $(this).addClass('d-none');
        $(this).siblings().removeClass('d-none');
      }

      $heroHome.slick('slickPlay');
    });

    if ($slides.length < 2) {
      $('.js-hero-home').find('.btn-wrapper').hide();
    }
  }

  return {init: _init};
})();

export default heroHome;

